import PrimerSessionIntentProps from "../../../../content/sdk/ios/2.x.x/_common/_props/PrimerSessionIntentPropsIos.mdx";
import ComponentStartiOS from "../../../../content/sdk/ios/2.x.x/primerHeadlessUniversalCheckout/_common/componentStart.mdx";
import ComponentFormRedirectSubmitiOS from "../../../../content/sdk/ios/2.x.x/primerHeadlessUniversalCheckout/_componentWithRedirect/componentSubmit.mdx";
import ComponentErroriOS from "../../../../content/sdk/ios/2.x.x/primerHeadlessUniversalCheckout/_common/componentError.mdx";
import ComponentValidationErroriOS from "../../../../content/sdk/ios/2.x.x/primerHeadlessUniversalCheckout/_common/componentValidationError.mdx";
import ComponentKlarnaStepsiOS from "../../../../content/sdk/ios/2.x.x/primerHeadlessUniversalCheckout/_klarna/klarnaComponentStep.mdx";
import ComponentKlarnaUpdateCollectedDataiOS from "../../../../content/sdk/ios/2.x.x/primerHeadlessUniversalCheckout/_klarna/klarnaComponentUpdateCollectedData.mdx";
import ComponentKlarnaAssociatedTypes from "../../../../content/sdk/ios/2.x.x/primerHeadlessUniversalCheckout/_klarna/klarnaComponentAssociatedTypes.mdx";
import * as React from 'react';
export default {
  PrimerSessionIntentProps,
  ComponentStartiOS,
  ComponentFormRedirectSubmitiOS,
  ComponentErroriOS,
  ComponentValidationErroriOS,
  ComponentKlarnaStepsiOS,
  ComponentKlarnaUpdateCollectedDataiOS,
  ComponentKlarnaAssociatedTypes,
  React
};